export default "__VITE_ASSET__98H7gz_Q__"